import React from 'react';
import { connect } from 'react-redux';
import del from '../Res/Icon/delete.png';
import download from '../Res/Icon/download.png';
import recover from '../Res/Icon/recover.png';
import delivered from '../Res/Tags/Delivered.png';
import failed from '../Res/Tags/Failed.png';
import sending from '../Res/Tags/Sending.png';
import cancelled from '../Res/Tags/Cancelled.png';
import './Fax.css';
import SpinnerCircles from './Spinner/SpinerCircles';
import utils from '../lib/utils';

const IncomingFax = ({ fax, onDelete, onDownload, user: userApp, deleteMode, onRecover }) => {
  const { _id: id, outgoingFax, updatedOn, user, company, senderNum, recieverNum } = fax;
  return (
    <tr>
      {/* {userApp.role === "superAdmin" || userApp.role === 'companyGroupAdmin' && <td>{id}</td>} */}
      <td>{company.name}</td>
      <td>{(outgoingFax && outgoingFax.reason) || 'Processed'}</td>
      <td>{user.email}</td>
      <td>{utils.getDateTimeFormat(updatedOn, 'regular')}</td>
      <td>{(recieverNum && recieverNum?.number) || ''}</td>
      <td>{senderNum}</td>
      {outgoingFax && outgoingFax?.status ? (
        <td>
          {outgoingFax && outgoingFax.status === 'Delivered' ? (
            <img className="actions-tags" src={delivered} alt="..." />
          ) : outgoingFax && outgoingFax.status === 'Sending' ? (
            <img className="actions-tags" src={sending} alt="..." />
          ) : (outgoingFax && outgoingFax.status === 'Failed') ||
            (outgoingFax && outgoingFax.status === 'failed') ? (
            <img className="actions-tags" src={failed} alt="..." />
          ) : (
            <img className="actions-tags" src={cancelled} alt="cancelled" />
          )}
        </td>
      ) : (
        <td>
          <img className="actions-tags" src={delivered} alt="..." />
        </td>
      )}

      {!deleteMode ? (
        <td>
          <div style={{ display: 'flex' }}>
            {((userApp?.role === 'admin' || userApp?.role === 'enterpriseAdmin') &&
              userApp.company.permissions.showFaxDownload) ||
              (user._id === userApp._id && userApp.company.permissions.showFaxDownload) ? (
              <img
                onClick={() => {
                  onDownload(id);
                }}
                className="actions-icon"
                src={download}
                alt="..."
              />
            ) : null}
            <img
              onClick={() => {
                onDelete(id);
              }}
              className="actions-icon"
              src={del}
              alt="..."
            />
          </div>
        </td>
      ) : (
        <td>
          <div style={{ display: 'flex' }}>
            <img
              onClick={() => {
                onDelete(id);
              }}
              className="actions-icon"
              src={del}
              alt="..."
            />
            <img onClick={() => onRecover(id)} className="actions-icon" src={recover} alt="..." />
          </div>
        </td>
      )}
      {/*
        <FaxStatus status={status} retryCount={retryCount} />
        */}
    </tr>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(IncomingFax);
